<template>
  <div class="main-wrapper">
    <main class="main-content" role="main">
      <div id="promo">
        <div class="jumbotron">
          <h1>Eiscaf&eacute; &amp; Coffeeshop</h1>
          <p><strong class="textbold">Eissaison 2026</strong><br>
          Wir sind für Sie da und freuen uns auf Ihren Besuch.</p>
        </div>
      </div>
       
<!--       <div class="container site-section" id="welcome">
        <h1>Aktueller Hinweis</h1>
        <p class="aktuell">Ostern 2024 haben wir geöffnet</p>
        <p class="aktuell2">Karfreitag 14:00 - 19:00 Uhr</p>
        <p class="aktuell2">Samstag 14:00 - 19:00 Uhr</p>
        <p class="aktuell2">Ostersonntag 12:00 - 19:00 Uhr</p>
        <p class="aktuell2">Ostermontag 12:00 - 19:00 Uhr</p>
      </div> -->

      <div class="container site-section" id="welcome">
        <h1>Liebe EISART - Kunden</h1>
        <p>Leider will das Wetter nicht immer so, wie wir es uns wünschen.</p>
        <p>
          Deshalb kann es passieren, dass wir unser Eiscaf&eacute; auch mal früher schließen, 
          oder natürlich auch gern mal länger für Sie da sind.
        </p>
        <p>Vielen Dank für Ihr Verständnis!</p>
      </div>

      <div class="container site-section" id="welcome">
        <h1>Das besondere Eisvergnügen</h1>
        <p>Kommen Sie und genießen ein ganz besonderes Eisvergnügen im geschmackvoll eingerichteten Caf&eacute; oder auf der Terasse.</p>
        <img src="../../assets/img/eisart-laden.jpg"/>
      </div>

    <div>
        <div class="container site-section" id="why">
            <h1>Was macht uns besonders?</h1>
            <div class="row">
                <div class="col offset-xl-0 item"><i class="fas fa-ice-cream"></i>
                    <h2>Produktion</h2>
                    <p>Unser Eis wird nach tradioneller Rezeptur in eigener Handarbeit hergestellt.</p>
                </div>
                <div class="col item"><i class="fas fa-heart"></i>
                    <h2>Geschmack</h2>
                    <p>Es werden die besten Zutaten verwendet. Dabei legen wir viel Wert auf die Frische und Qualität.</p>
                </div>
                <div class="col item"><i class="fa fa-shopping-basket"></i>
                    <h2>Vielfalt</h2>
                    <p>Wir wechseln ständig unser Angebot aus einem 60 Sorten umfassenden Sortiment.</p>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>

    </main>
    <aside class="aside" role="complementary">
      <div>
        <h3>Öffnungszeiten</h3>
        <p>Montag: geschlossen</p>
        <p>Di - Sa: 14:00 - 19:00 Uhr</p>
        <p>(bei schönem Wetter bis 20:00 Uhr)</p>
        <p>So: 12:00 - 19:00 Uhr</p>
        <p>(bei schönem Wetter bis 20:00 Uhr)</p>
      </div>
      <div style="height:10px"></div>
      <div>
        <h2>Eisart</h2>
        <p>Kiebitzweg 41</p>
        <p>22869 Schenefeld</p>
        <p>Tel.: (040) 840 518 12</p>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: "KastenmodellView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";
@import 'bootstrap/dist/css/bootstrap.css';
@import 'bootstrap-vue/dist/bootstrap-vue.css';

.aktuell {
  background-color: red;
  color: white;
}
.aktuell2 {
  background-color: white;
  color: black;
  font-weight: 900;
}
.textbold {
  font-weight: 900;
  font-size: larger;
}
#promo {
  text-align: center;
  padding: 40px;
  background: url(../../assets/img/eiswaffeln.jpg) no-repeat;
  background-size: cover;
}

@media (max-width: 991px) {
  #promo {
    padding: 20px;
  }
}

#promo .jumbotron {
  color:black;
  font-size: 1.75rem;
  border-radius: 20px;
  padding: 40px;
  background-color: rgba(235,230,200,0.75);
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 991px) {
  #promo .jumbotron {
    padding: 10px;
  }
}

.site-section {
  text-align: center;
  padding: 30px 0 10px;
}

#welcome p {
  max-width: 800px;
  font-size: 20px;
  margin: 10px auto;
}

.site-section h1 {
  font-weight: normal;
  margin-bottom: 30px;
}

#why .item i {
  font-size: 48px;
}

#why .item h2 {
  font-weight: normal;
}

img {
  max-width: 100%;
  height: auto;
}

@media (min-width:720px) and (max-width: 800px) {
.aside p {
  font-size: 1.5rem;
}
}

@media (min-width:640px) and (max-width: 720px) {
.aside p {
  font-size: 1.2rem;
}
}
</style>



// WEBPACK FOOTER //
// src/components/eisart/start.vue